import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { AIDetectorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/AIDetectorIcon";
import { TitleGeneratorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TitleGeneratorIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import WorkflowPreview from "./WorkflowPreview";
import { workflowTypes } from "../../../Types/Workflow-Types";
import DuplicateTemplateModal from "./DuplicateTemplateModal";
import { useCloneWorkflow } from "../../../store/Apis/WorkflowsApi";
import EyeIcon from "../../../Custom-imeges/Workflows-Icons/EyeIcon";
import FullArrowRightIcon from "../../../Custom-imeges/Workflows-Icons/FullArrowRightIcon";
import { useAppSelector } from "../../../store/hooks";
import TextToVideoIcon from "../../../Custom-imeges/VideoSuite/TextToVideoIcon";
import ImageToVideoIcon from "../../../Custom-imeges/VideoSuite/ImageToVideoIcon";
import WorkflowGuide from "./WorkflowGuide";
interface WorkflowTemplateCardProps {
  content: string;
  workflowData: workflowTypes;
  order: number;
}
const WorkflowTemplateCard = ({
  content,
  workflowData,
  order,
}: WorkflowTemplateCardProps) => {
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [showGuidePreview, setShowGuidePreview] = useState<boolean>(false);
  const [copyTemplate, setCopyTemplate] = useState<boolean>(false);
  const UserAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  const { CloneWorkflow, isSuccess: cloningSucceeded } = useCloneWorkflow();
  useEffect(() => {
    if (cloningSucceeded) setCopyTemplate(false);
  }, [cloningSucceeded]);
  const WorkflowAppsIconsBlue: { [key: string]: JSX.Element } = {
    Translator: <TranslatorIcon className="user-profile-edit-icon" />,
    Humanizer: <HumanizeIcon className="user-profile-edit-icon" />,
    Summarizer: <SummarizeIcon className="user-profile-edit-icon" />,
    Paraphraser: <ParaphraseIcon className="user-profile-edit-icon" />,
    AIDetector: <AIDetectorIcon className="user-profile-edit-icon" />,
    Titlegenerator: <TitleGeneratorIcon className="user-profile-edit-icon" />,
    "Prompt Generator": (
      <PromptEngineerIcon className="user-profile-edit-icon" />
    ),
    "Text to Image": <GenerateImgIcon className="user-profile-edit-icon" />,
    "Logo Generator": <GenerateLogoIcon className="user-profile-edit-icon" />,
    "Icon Generator": <GenerateIconIcon className="user-profile-edit-icon" />,
    "Illustration Generator": (
      <GenerateIllsturationsIcon className="user-profile-edit-icon" />
    ),
    "Image Restore": <ImageRestoreIcon className="user-profile-edit-icon" />,
    "Text Extractor": (
      <ImageTranscaptionIcon className="user-profile-edit-icon" />
    ),
    "Background Remover": <BgRemoverIcon className="user-profile-edit-icon" />,
    "Text to Video": <TextToVideoIcon className="user-profile-edit-icon" />,
    "Image to Video": <ImageToVideoIcon className="user-profile-edit-icon" />,
  };

  const handlePreviewWorkflow = () => {
    setShowPreview(true);
  };
  const handleCopyTemplate = (workflowName: string) => {
    CloneWorkflow({
      workflowId: workflowData.id,
      workflowName: workflowName,
    });
  };
  return (
    <>
      <Card className="workflow-template-card">
        <CardContent
          sx={{
            padding: "12px",
          }}
        >
          <Box className="d-flex align-items-center justify-content-between">
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "20px",
                letterSpacing: "0.1px",
              }}
            >
              {workflowData?.name}
            </Typography>
            {order === 0 ? (
              <Box
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: "400",
                  fontSize: "10px",
                  lineHeight: "16px",
                  letterSpacing: "0.5px",
                  color: "#12B6EA",
                  background: " var(--A_backgroundColor99)",
                  gap: "8px",
                  borderRadius: "24px",
                  padding: "2px 6px",
                }}
              >
                Featured guide
          </Box>
            ) : null}
          </Box>
          <Typography
            className="mt-2"
            sx={{
              fontFamily: "Roboto",
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: "0.5px",
            }}
          >
            {content}
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "flex-start",
              marginTop: "19px",
            }}
          >
            {workflowData?.apps?.map((app: any, i: number) => (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: " var(--A_backgroundColor99)",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    padding: "4px",
                  }}
                >
                  {
                    WorkflowAppsIconsBlue[
                      app.appType as keyof typeof WorkflowAppsIconsBlue
                    ]
                  }
                </Box>
                {i !== workflowData?.apps.length - 1 ? (
                  <Box>
                    <FullArrowRightIcon />
                  </Box>
                ) : null}
              </>
            ))}
          </Box>
        </CardContent>
        <CardActions>
          {
            order===0?
            <>
         <Box
            className="workflow-template-preview-btn"
            sx={{
              padding: "7px",
              borderRadius: "10px",
              border: "0.8px solid #12B6EA",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              width:"50%"
            }}
            onClick={() => setShowGuidePreview(true)}
          >
           Start Guide
          </Box>
              <button
            className={`apply-btn ${
              UserAuthenticated ? "not-disable" : "disable-btn"
            } workflow-template-btn w-50`}
            onClick={() => UserAuthenticated && setCopyTemplate(true)}
          >
            Copy
          </button>
            </>
            :
          <>
          <Box
            className="workflow-template-preview-btn"
            sx={{
              padding: "10px 7px",
              borderRadius: "10px",
              border: "0.8px solid #12B6EA",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => handlePreviewWorkflow()}
          >
            <EyeIcon />
          </Box>
          <button
            className={`apply-btn ${
              UserAuthenticated ? "not-disable" : "disable-btn"
            } workflow-template-btn`}
            onClick={() => UserAuthenticated && setCopyTemplate(true)}
          >
            Copy
          </button>
          </>
}
        </CardActions>
      </Card>
      {showPreview && (
        <WorkflowPreview
          show={showPreview}
          handleClose={() => setShowPreview(false)}
          subTitle={content}
          workflowData={workflowData}
        />
      )}
      {showGuidePreview && (
        <WorkflowGuide
          show={showGuidePreview}
          handleClose={() => setShowGuidePreview(false)}
          workflowData={workflowData}
        />
      )}
      {copyTemplate && (
        <DuplicateTemplateModal
          show={copyTemplate}
          handleClose={() => setCopyTemplate(false)}
          templateName={workflowData?.name || ""}
          method={handleCopyTemplate}
        />
      )}
   
    </>
  );
};

export default WorkflowTemplateCard;
